import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import React from 'react'
import { Helmet } from "react-helmet"
import Accordion from '../components/Accordion'
import CallOut from '../components/CallOut'
import Card from '../components/Card'
import CardContainer from '../components/CardContainer'
import Carousel from '../components/Carousel'
import CMSModal from '../components/CMSModal'
import FactBox from '../components/FactBox'
import FlipCard from '../components/FlipCard'
import FlipCardContainer from '../components/FlipCardContainer'
import HeaderWithImage from '../components/HeaderWithImage'
import HTTTYP from '../components/HTTTYP'
import LinkButton from '../components/LinkButton'
import Question from '../components/Question'
import ShowMore from '../components/ShowMore'
import Slide from '../components/Slide'
import TextCarousel from '../components/TextCarousel'
import TextSlide from '../components/TextSlide'
import TopicTemplate from '../components/TopicTemplate'


function Topic({pageContext}) {
  const shortcodes = { 
    Accordion, FactBox, Carousel, Slide, Card, CardContainer, 
    ShowMore, HeaderWithImage, FlipCard, TextCarousel, TextSlide, Question,
    LinkButton, HTTTYP, FlipCardContainer, CMSModal, CallOut
  }
  const { topic } = pageContext

  return (
    <div className="Topic">
      <Helmet>
        <title>{topic.frontmatter.topicTitle}</title>
        <meta name="description" content={topic.frontmatter.topicTitle} />
      </Helmet>
      <TopicTemplate
        topicTitle={topic.frontmatter.topicTitle}
        sectionTitle={topic.frontmatter.sectionTitle}
        image={topic.frontmatter.image}
        path={topic.slug}>
        <MDXProvider components={shortcodes}>
          <MDXRenderer>
            {topic.body}
          </MDXRenderer>
        </MDXProvider>
      </TopicTemplate>
    </div>
  )
}

export default Topic;